import { render } from "./PickedResource.vue?vue&type=template&id=70de1c28"
import script from "./PickedResource.vue?vue&type=script&lang=js"
export * from "./PickedResource.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__